module.exports = __webpack_public_path__ + "media/images/icons/star-pink-empty-de61463cd4fe0fa144649c64e9af197f.svg";